/// place to hold common logic for decrypting "ChannelMessage" payloads
export class StreamStateView_ChannelMessages {
    streamId;
    parent;
    constructor(streamId, parent) {
        this.streamId = streamId;
        this.parent = parent;
    }
    onDecryptedContent(_eventId, _content, _stateEmitter) {
        // pass
    }
    appendChannelMessage(event, cleartext, encryptionEmitter, stateEmitter, value) {
        this.parent.decryptEvent('channelMessage', event, value, cleartext, encryptionEmitter);
    }
    prependChannelMessage(event, cleartext, encryptionEmitter, stateEmitter, value) {
        this.parent.decryptEvent('channelMessage', event, value, cleartext, encryptionEmitter);
    }
}
//# sourceMappingURL=streamStateView_Common_ChannelMessages.js.map